import { render, staticRenderFns } from "./Correspondence.vue?vue&type=template&id=879fd288&"
import script from "./Correspondence.vue?vue&type=script&lang=js&"
export * from "./Correspondence.vue?vue&type=script&lang=js&"
import style0 from "./Correspondence.vue?vue&type=style&index=0&id=879fd288&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports